import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DEFAULT_INVOICES } from 'shared/constants/payments';

const state = {
  paymentsAccount: {},
  paymentStatus: null,
  invoices: DEFAULT_INVOICES,
  uiFlags: {
    isFetching: false,
    isPaymentStatusFetching: false,
    isUnpaidInvoiceBannerDismissed: false,
    isInvoicesFetchError: false,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
